var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorporatePulse({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20.0 20.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cpi0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.222,0 L6.222,2.5 L5.222,2.5 L5.222,1.707 L2.894,4.036 L2.054,3.196 L0.707,4.542 L0,3.835 L2.054,1.781 L2.894,2.621 L4.515,1 L3.722,1 L3.722,0 L6.222,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cpi1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.707,0 L2.053,1.346 L2.893,0.506 L5.222,2.835 L5.222,2.042 L6.222,2.042 L6.222,4.542 L3.722,4.542 L3.722,3.542 L4.515,3.542 L2.893,1.921 L2.053,2.761 L0,0.707 L0.707,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cpi2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,0 L20,20 L0,20 L0,0 L20,0 Z M19,10.5 L1,10.5 L1,19.001 L19,19.001 L19,10.5 Z M19,1 L1,1 L1,9.5 L19,9.5 L19,1 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.8889 2.478999999999999)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cpi0)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 6.222,0 6.222,4.542 0,4.542 0,0",
    stroke: "none",
    fill: "#666666"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.889200000000001 12.979)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cpi1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 6.222,0 6.222,4.542 0,4.542 0,0",
    stroke: "none",
    fill: "#666666"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cpi2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 20,0 20,20 0,20 0,0",
    stroke: "none",
    fill: "#666666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporatePulse);
export default __webpack_public_path__ + "static/media/CorporatePulse.6e194f842bd07548f5472f49b0bc9ea2.svg";
export { ForwardRef as ReactComponent };